<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="外销合同编号：">
        <order-drop v-model="dataForm.orderCode" clearable></order-drop>
      </el-form-item>
      <el-form-item label="发货方：">
        <el-input size="mini" v-model="dataForm.senderName" clearable></el-input>
      </el-form-item>
      <el-form-item label="收货方：">
        <el-input size="mini" v-model="dataForm.receiverName" clearable></el-input>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="businessMan" label="业务担当：">
        <el-input
            v-model="dataForm.businessMan"
            size="mini"
            clearable
            type="text"
            placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="reason" label="变动原因：">
        <el-select v-model="dataForm.reason" size="mini" clearable>
          <el-option value="" label="全部"></el-option>
          <el-option value="生产入库" label="生产入库"></el-option>
          <el-option value="库存调配" label="库存调配"></el-option>
          <el-option value="箱单出库" label="箱单出库"></el-option>
          <el-option value="库存初始化" label="库存初始化"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="dataForm.orderStatus" label="已结束合同" :true-label="200" false-label=""></el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="flex-b">
      <div class="flex-l">
        <el-button type="primary" size="mini" @click="doExport()">
          导出EXCEL
        </el-button>
      </div>
      <div class="flex-l">
        <div class="flex-l">
          <div style="width: 20px;height: 20px;background-color:red;margin: 0 4px 0 10px;"></div>
          <div style="color:red;">数量存疑</div>
        </div>
        <div class="flex-l">
          <div style="width: 20px;height: 20px;background-color:#a400a2;margin: 0 4px 0 10px;"></div>
          <div style="color:#a400a2;">有剩余库存</div>
        </div>
      </div>
    </div>
    <SweetTable ref="table" url="/erp/store/report/page" :query-form="dataForm"
                :before-table-binding="beforeTableBinding" :cell-style="cellStyleHandler"
                :summariesColumn="['totalAmount','useCount','limitCount','productSendCount']" api-version="v2">
      <el-table-column
          prop="orderCode"
          label="外销合同"
          header-align="center"
          align="left" width="160"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="senderName"
          label="工厂名称"
          header-align="center"
          align="left" width="160"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="businessManName"
          label="业务担当"
          header-align="center"
          align="left" width="160"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          label="品番"
          header-align="center"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <ProductRowCard :product="row.product"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column prop="count" label="收货数量" header-align="center" align="center" width="80" fixed="right">
      </el-table-column>
      <el-table-column
          prop="finalSendCount"
          label="出口/内销数量"
          header-align="center"
          align="center" width="120" fixed="right"
      >
      </el-table-column>
      <el-table-column
          prop="limitCount"
          label="剩余数量"
          header-align="center"
          align="center" width="80" fixed="right"
      >
      </el-table-column>
      <el-table-column
          prop="remark"
          :show-overflow-tooltip="true"
          label="备注"
          header-align="center"
          align="center" width="80" fixed="right"
      >
      </el-table-column>
      <el-table-column
          label="操作"
          header-align="center"
          align="center" width="80" fixed="right"
      >
        <template #default="{row}">
          <el-button type="text" size="mini" @click="showRemarkDialog(row)">备注</el-button>
        </template>
      </el-table-column>

    </SweetTable>
    <MaterialUseList ref="MaterialUseList"></MaterialUseList>
    <MaterialReceiveList ref="MaterialReceiveList"></MaterialReceiveList>
    <RemarkDialog ref="remarkDialog" bisKey="成品库存"></RemarkDialog>
  </div>
</template>

<script>
import RemarkDialog from '@/views/modules/common/remark-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'
import MaterialUseList from '@/views/modules/settle/report/material-use-list.vue'
import MaterialReceiveList from '@/views/modules/settle/report/material-receive-list.vue'
import ProductRowCard from '@/components/ProductRowCard.vue'

export default {
  name: 'product-store',
  mixins: [SweetTable],
  components: { ProductRowCard, MaterialUseList, MaterialReceiveList, RemarkDialog },
  data () {
    return {
      dataForm: {
        reason: '',
        orderCode: '',
        senderName: '',
        receiverName: '',
        productCode: '',
        skuCode: '',
        productName: '',
        productColor: '',
        productSize: '',
        businessMan: '',
        orderStatus: 200
      }
    }
  },
  methods: {
    showRemarkDialog (row) {
      let bisId = row.orderId + '-' + row.senderId + '-' + row.productId
      this.$refs.remarkDialog.init(bisId)
    },
    doExport () {
      this.$export(`/erp/store/report/export`, this.dataForm, null, 'v2')
    },
    cellStyleHandler ({ row, column, rowIndex, columnIndex }) {
      if (row.limitCount < 0) {
        return {
          color: 'red'
        }
      } else if (row.limitCount > 0) {
        return {
          color: '#a400a2'
        }
      }
    },
    showMaterialReceiveList (row) {
      this.$refs.MaterialReceiveList.materialInfo = row.materialInfo
      this.$refs.MaterialReceiveList.init(row.companyId, row.materialId, row.orderId)
    },
    showMaterialUseList (row) {
      this.$refs.MaterialUseList.materialInfo = row.materialInfo
      this.$refs.MaterialUseList.init(row.companyId, row.materialId, row.orderId)
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.limitCount = new BigNumber(row.count).minus(row.finalSendCount).toNumber()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
